import Logo from '../assets/logo.png';
import LogoWhite from '../assets/logo-white.png';

export const Light = {
    title: 'light',
    background: '#ECEDEE',
    font: '#2E2E2E',
    white: '#fff',
    primary: '#4DBFD9',
    hover: '#f3f3f3',
    logo: Logo
};

export const Dark = {
    title: 'dark',
    background: '#22242A',
    font: '#e5e5e5',
    white: '#363D46',
    primary: '#4DBFD9',
    hover: '#2E333B',
    logo: LogoWhite
};